import { render } from "./Voordelen.vue?vue&type=template&id=0dcb08b4&scoped=true"
import script from "./Voordelen.vue?vue&type=script&lang=js"
export * from "./Voordelen.vue?vue&type=script&lang=js"

import "./Voordelen.vue?vue&type=style&index=0&id=0dcb08b4&scoped=true&lang=scss"

import exportComponent from "/Users/Sacha/Projects/ftminstallatietechniek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb08b4"]])

export default __exports__